import { Quote } from "lucide-react";
import { STORIES } from "./data/content";
import Reveal from "./Reveal";
import PhotoSlot from "./PhotoSlot";

export const Stories = () => (
  <section id="stories" className="py-16 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <p className="label-mono">Success stories</p>
        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
          Success in their words.
        </h2>
        <p className="mt-5 text-base leading-relaxed text-slate-400 sm:text-lg">
          Real Agency HQ agents — their stories, their brands, their numbers.
        </p>
      </Reveal>

      {/* featured video */}
      <Reveal delay={0.05}>
        <div className="mx-auto mt-12 max-w-4xl" data-testid="feature-video-1">
          <PhotoSlot file="video-explained.mp4" kind="video" label="Agency HQ explained" aspect="aspect-video" />
          <p className="mt-3 text-center font-display text-sm font-semibold tracking-tight text-slate-300">
            Agency HQ explained
          </p>
        </div>
      </Reveal>

      {/* agent stories */}
      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {STORIES.map((s, i) => (
          <Reveal key={s.key} delay={0.08 * i} className="h-full">
            <article
              className="group flex h-full flex-col rounded-2xl border border-white/10 bg-panel/60 transition-all duration-200 hover:-translate-y-1 hover:border-gold/40"
              data-testid={`testimonial-card-${i + 1}`}
            >
              {s.photo ? (
                <PhotoSlot
                  file={s.photo}
                  label={s.name}
                  aspect="aspect-[4/3] rounded-b-none border-0"
                  imgPosition={s.key === "peter" ? "center 12%" : "center"}
                />
              ) : (
                <PhotoSlot
                  file={s.video}
                  kind="video"
                  label={`${s.name} — video testimonial`}
                  aspect="aspect-[16/10] rounded-b-none border-0"
                />
              )}
              <div className="flex flex-1 flex-col p-6 sm:p-7">
                <Quote className="h-5 w-5 text-gold-light" fill="currentColor" aria-hidden="true" />
                {s.quote ? (
                  <p className="mt-4 font-display text-lg font-medium leading-snug text-white">
                    &ldquo;{s.quote}&rdquo;
                  </p>
                ) : (
                  <p className="mt-4 text-sm italic leading-relaxed text-slate-500">
                    Event highlights and participant testimonials from the Kickstart program — agents
                    building their brands in their first months on the platform.
                  </p>
                )}
                <div className="mt-auto pt-6">
                  <p className="font-display text-base font-bold text-white" data-testid={`testimonial-name-${i + 1}`}>
                    {s.name}
                  </p>
                  <p className="label-mono mt-1 !text-[10px]">{s.tag}</p>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Stories;
